import React, { useState } from "react";
import "./header.scss";
import { Link } from "react-router-dom";
import Menu from "../memu/Menu";
import { useGetPageQuery } from "../../redux/services/crmAPI";
import { useDispatch } from "react-redux";
import { setCurrency } from "../../redux/slices/statusSlice";
import { useEffect } from "react";
import MobileMenu from "../memu/mobileMenu/MobileMenu";
import MobileMenuList from "../memu/mobileMemuList/MobileMenuList";

const Header = () => {
    const dispatch = useDispatch();

    const [openMenu, setOpenMenu] = useState(false);

    const { data: currencies } = useGetPageQuery("currencies");

    useEffect(() => {
        if (currencies) {
            const usd = currencies.filter((currency) => currency.currency === "usd")[0];
            dispatch(setCurrency(+`${usd.bid.toString().slice(0, -2)}.${usd.bid.toString().slice(-2)}`));
        }
    }, [currencies]);

    return (
        <>
            {currencies && (
                <div className="header">
                    <div className="header__container _conatiner">
                        <div className="header__stock">
                            <Link className="header__stock-link" to={"/"}>
                                Склад
                            </Link>
                            <div className="header__stock-exchange">
                                {currencies.map((currency) => {
                                    if (currency.currency === "usd") {
                                        return (
                                            <div className="header__stock-exchange-usd" key={currency.id}>
                                                ${" "}
                                                {
                                                    +`${currency.bid.toString().slice(0, -2)}.${currency.bid
                                                        .toString()
                                                        .slice(-2)}`
                                                }
                                                /{" "}
                                                {
                                                    +`${currency.ask.toString().slice(0, -2)}.${currency.ask
                                                        .toString()
                                                        .slice(-2)}`
                                                }
                                            </div>
                                        );
                                    } else if (currency.currency === "eur") {
                                        return (
                                            <div className="header__stock-exchange-usd" key={currency.id}>
                                                €{" "}
                                                {
                                                    +`${currency.bid.toString().slice(0, 2)}.${currency.bid
                                                        .toString()
                                                        .slice(2, 4)}`
                                                }
                                                /{" "}
                                                {
                                                    +`${currency.ask.toString().slice(0, 2)}.${currency.ask
                                                        .toString()
                                                        .slice(2, 4)}`
                                                }
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </div>
                        <div className="desctop-menu">
                            <Menu />
                        </div>
                        <div className="mobile-menu">
                            <MobileMenu openMenu={openMenu} setOpenMenu={setOpenMenu} />
                        </div>
                    </div>

                    <MobileMenuList openMenu={openMenu} setOpenMenu={setOpenMenu} />
                </div>
            )}
        </>
    );
};

export default Header;
